(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section-wishlist"] && !Shopify.designMode) return;
  try {
    
  
  function createWishListTplItem(ProductHandle) {
    var wishListCotainer = $('[data-wishlist-container]');
    // console.log(currencyFormat)
   
    // jQuery.getJSON(window.Shopify.routes.root + '/products/'+ProductHandle+'.js', function(product) {
    jQuery.getJSON('/products/'+ProductHandle+'.js', function(product) {
        var productHTML = '';
        price_min = Shopify.formatMoney(product.price_min);
        compare_at_price_min = Shopify.formatMoney(product.compare_at_price_min);
        // console.log('product.price_min',product.price_min) 8500
        // price_min = "$ " + String(Number(product.price_min/100).toFixed(2)) + " SGD";  
        // compare_at_price_min = "$ " + String(Number(product.compare_at_price_min/100).toFixed(2)) + " SGD";  
      
        productHTML += '<div class="grid-item" data-wishlist-added="wishlist-'+product.id+'">';
        productHTML += '<div class="inner product-item" data-product-id="product-'+product.handle+'">';
        productHTML += '<div class="column col-remove text-center"><a class="whislist-added" href="#" data-product-handle="'+ product.handle +'" data-icon-wishlist data-id="'+ product.id +'"><svg class="closemnu" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg></a></div>';
        productHTML += '<div class="column col-img"><div class="product-image">';
        productHTML +='<a href="'+product.url+'" class="product-grid-image" data-collections-related="/collections/all?view=related">';
        if (product.featured_image) {
            productHTML += '<div class="product-single__media product-single__media--image">'
            productHTML += '<div class="product-single__media--image-height" style="padding-top: 100.0%;"></div>'
            productHTML += '<figure class="lazy-image lazy-image--cover"><img src="'+product.featured_image+'"></figure>'
            
            productHTML += '<a href="'+product.url+'" class="product-single__media-link" rel="lightbox" data-zoom-wrapper="" data-image-width="800" data-image-height="800"><span class="visually-hidden">Open image lightbox</span></a></div>'
              
            // productHTML += '<img src="'+product.featured_image+'" alt="'+product.featured_image.alt+'">';
        }
        productHTML += '</a></div></div>';
        productHTML += '<div class="column col-prod">';
        productHTML += '<a class="product-title" href="'+product.url+'" title="'+product.title+'">'+product.title+'</a>';
        // productHTML += '<br/><span style="font-size:12px;">SKU: '+product.variants[0].sku+'</span>';

        // console.log("product",product.variants[0].sku)
        if (product.compare_at_price_min > product.price_min){
          productHTML += '<br/>'+'<s class="product__price--compare">'+compare_at_price_min+'</s><span class="wishlist_price_new">'+price_min+'</span></div>';
        }
        else{
          productHTML += '<br/>'+price_min+'</div>';
        }
        productHTML += '<div class="column col-options text-center">';
        productHTML += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + product.id +'" data-id="product-actions-'+product.id+'" enctype="multipart/form-data">';

        if (product.available) {
            if (product.variants.length == 1) {
                
                // productHTML += '<a class="btn btn--primary btn--solid btn--large" title="'+product.title+'" href="' + product.url +'">'+"Add To Cart"+'</a>';
                // here is add to cart
                productHTML += '<form method="post" action="/cart/add" id="AddToCartForm--template" class="product__form" enctype="multipart/form-data" data-product-form data-recipient-errors="false">'
                productHTML += '<input type="hidden" name="id" value="'+ product.variants[0].id +'" />'
                productHTML += '<input type="hidden" id="quantity" name="quantity" value="1"/>'
                productHTML += '<div class="product__submit__buttons">'
                productHTML += '<div class="product__submit__item aos-init aos-animate" data-aos="hero" data-aos-anchor="#FeaturedProduct--template--14762754441280__main" data-aos-order="1">'
                productHTML += '<input type="submit" value="Add to cart" class=" button button--full-width button--secondary" /></div></div></form>'

                // productHTML += '<form method="post" action="/cart/add" id="template--14784120225856__6bfea71a-7d74-4bb1-abc0-d5d89ff9707c-6824119107648" accept-charset="UTF-8" class="quick__form" enctype="multipart/form-data" data-product-form="" data-quickbuy-form=""><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="quantity" value="1"><input type="hidden" name="id" value="39935820955712"><button type="submit" name="add" class="btn--quick rounded" data-add-to-cart="" data-atc-trigger="" tabindex="1"><span class="btn__inner"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-shopping-bag" viewBox="0 0 192 192"><path d="M156.6 162H35.4a6.075 6.075 0 0 1-6-5.325l-10.65-96A6 6 0 0 1 24.675 54h142.65a6.001 6.001 0 0 1 5.925 6.675l-10.65 96a6.076 6.076 0 0 1-6 5.325v0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M66 78V54a30 30 0 1 1 60 0v24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><circle class="cart-indicator" cx="96" cy="108" r="15"></circle></svg><span class="btn__text">Quick Buy</span><span class="btn__loader"><svg height="18" width="18" class="svg-loader"><circle r="7" cx="9" cy="9"></circle><circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle></svg></span></span></button><div class="product-grid-item__error" role="alert" data-cart-errors-container=""></div><input type="hidden" name="product-id" value="6824119107648"><input type="hidden" name="section-id" value="template--14784120225856__6bfea71a-7d74-4bb1-abc0-d5d89ff9707c"></form>'
            }
            if (product.variants.length > 1){
                productHTML += '<a class=" button button--full-width button--secondary" title="'+product.title+'" href="' + product.url +'">'+"View Product"+'</a>';
                // productHTML += '<a class="btn" title="'+product.title+'" href="' + product.url +'">'+window.inventory_text.select_options+'</a>';
            }
        } else {
            productHTML += '<button class="button button--full-width button--secondary variant--soldout" type="submit" disabled="disabled">'+"Unavailable"+'</button>';
            // productHTML += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">'+window.inventory_text.unavailable+'</button>';
        }
        
      
        productHTML += '</form></div>';
        productHTML += '</div></div>';

        // console.log('wishListCotainer',wishListCotainer)
        // console.log('productHTML',productHTML)
        // console.log('product',ProductHandle)
      
        wishListCotainer.append(productHTML);
        // var regex = /(<([^>]+)>)/ig;
        // var href = $('.wrapper-wishlist a.share').attr("href");
        // // href += encodeURIComponent( product.title + '\nPrice: ' + price_min.replace(regex, "") + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
        // href += encodeURIComponent( product.title + '\nPrice: ' + price_min + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
        
        // $('.wrapper-wishlist a.share').attr("href", href );
    });
}

  
  function doAddOrRemoveWishlish() {
    var iconWishListsSlt = '[data-icon-wishlist]';

    $(document).off('click.addOrRemoveWishlist', iconWishListsSlt).on('click.addOrRemoveWishlist', iconWishListsSlt, function(e) {
        e.preventDefault();

        var self = $(this),
        productId = self.data('id'),
        ProductHandle = self.data('product-handle'),
        wishListsArr = localStorage.getItem('shopify-wishlist').split(",")
        // console.log("before",localStorage.getItem('shopify-wishlist'))
        idxArr = wishListsArr.indexOf(ProductHandle);

        if(!self.hasClass('whislist-added')) {
            self.addClass('whislist-added');
           
            if($('[data-wishlist-container]').length) {
                createWishListTplItem(ProductHandle);
            };

            wishListsArr.push(ProductHandle);
            localStorage.setItem('shopify-wishlist', JSON.stringify(wishListsArr));
        } else {
            self.removeClass('whislist-added');
            
            if($('[data-wishlist-added="wishlist-'+productId+'"]').length) {
                $('[data-wishlist-added="wishlist-'+productId+'"]').remove();
            }

            wishListsArr.splice(idxArr, 1);
            localStorage.setItem('shopify-wishlist',JSON.stringify(wishListsArr).replace(/"/g, '').replace(/'/g, '').replace("[",'').replace("]",''));
            updateWishlistCount();
            
            if($('[data-wishlist-container]').length) {
                initWishListPagging();
            };
        };

        // ella.setAddedForWishlistIcon(ProductHandle);
    });
}

  doAddOrRemoveWishlish();
  
  function initWishListPagging() {
    var data = localStorage.getItem('shopify-wishlist').split(",")
    var wlpaggingContainer = $('#wishlist-paginate');
    var paggingTpl = '<li class="text disabled prev"><a href="#" title="prev"><i class="fa fa-angle-left" aria-hidden="true"></i><span>prev</span></a></li>';
    var wishListCotainer = $('[data-wishlist-container]');

    wlpaggingContainer.children().remove();

    var totalPages = Math.ceil(data.length / 3);

    if (totalPages <= 1) {
        wishListCotainer.children().show();
        return;
    }

    for (var i = 0; i < totalPages; i++) {
        var pageNum = i + 1;
        if (i === 0) paggingTpl += '<li class="active"><a data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
        else paggingTpl += '<li><a data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
    }

    paggingTpl += '<li class="text next"><a href="#" title="next"><span>next</span><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>';

    wlpaggingContainer.append(paggingTpl);

    wishListCotainer.children().each(function(idx, elm) {
        if (idx >= 0 && idx < 3) {
            $(elm).show();
        }
        else {
            $(elm).hide();
        }
    });

    wlpaggingContainer.off('click.wl-pagging').on('click.wl-pagging', 'li a', function(e) {
        e.preventDefault();

        var isPrev = $(this).parent().hasClass('prev');
        var isNext = $(this).parent().hasClass('next');
        var pageNumber = $(this).data('page');

        if (isPrev) {
            var curPage = parseInt($(this).parent().siblings('.active').children().data('page'));
            pageNumber = curPage - 1;
        }

        if (isNext) {
            var curPage = parseInt($(this).parent().siblings('.active').children().data('page'));
            pageNumber = curPage + 1;
        }

        wishListCotainer.children().each(function(idx, elm) {
            if (idx >= (pageNumber - 1) * 3 && idx < pageNumber * 3) {
                $(elm).show();
            }
            else {
                $(elm).hide();
            }
        });

        if (pageNumber === 1) {
            wlpaggingContainer.find('.prev').addClass('disabled');
            wlpaggingContainer.find('.next').removeClass('disabled');
        }
        else if (pageNumber === totalPages) {
            wlpaggingContainer.find('.next').addClass('disabled');
            wlpaggingContainer.find('.prev').removeClass('disabled');
        }
        else {
            wlpaggingContainer.find('.prev').removeClass('disabled');
            wlpaggingContainer.find('.next').removeClass('disabled');
        }

        $(this).parent().siblings('.active').removeClass('active');
        wlpaggingContainer.find('[data-page="' + pageNumber + '"]').parent().addClass('active');

    });
}
  
  function initWishLists() {
    if (typeof(Storage) !== 'undefined') {

        const wishlist = localStorage.getItem('shopify-wishlist');
        var data
        if (wishlist) {
            // Only split if wishlist is not null
            const wishlistItems = wishlist.split(",");
            data = wishlist.split(",")
            // Proceed with the wishlist items

            console.log("data",data)
            if (data.length <= 0) {
                $(".wrapper-wishlist").addClass("empty");
                return;
            }
            
            $(".wrapper-wishlist").removeClass("empty");
            data.forEach(function(item) {
                createWishListTplItem(item);
            });

            initWishListPagging();
        } else {
            $('.wishlist_placeholder').css('display', 'block');
            $(".wrapper-wishlist").addClass("empty");
            console.log("Wishlist is empty or not available.");
        }
    } else {
        alert('Sorry! No web storage support..');
    }
}

  initWishLists()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
